import React from 'react';
import ReactDOM from 'react-dom';
import { initializeIcons } from '@fluentui/react/lib/Icons';
import { ThemeProvider } from '@fluentui/react';
import { ubgTheme } from './theme';
import RegistrationForm from './components/RegistrationForm';
 
// Initialize FluentUI icons
initializeIcons();
 
// Function to initialize the form
const initializeForm = () => {
  const container = document.getElementById('ubg-registration-form-container');
 
  if (container) {
    ReactDOM.render(
      <ThemeProvider theme={ubgTheme}>
        <RegistrationForm />
      </ThemeProvider>,
      container
    );
  }
};
 
// Try to initialize immediately
initializeForm();
 
// Also try after DOM is loaded
document.addEventListener('DOMContentLoaded', initializeForm);
 
// And try again after a short delay to catch any dynamic loading
setTimeout(initializeForm, 1000);
 
// For WordPress, also try when the page is fully loaded
window.addEventListener('load', initializeForm);